import { isUndefined } from "./utils";

export function defineDirective(controllerType: (new (...args: any[]) => ng.IController), templateUrl: string, scope?: any): ng.IDirective {

    return {

        templateUrl: templateUrl,
        scope: (isUndefined(scope) ? {} : scope),
        controller: controllerType,
        controllerAs: "vm",
        bindToController: true,

    }

}

export function defineComponent(controllerType: any, templateUrl: string, scope?: any) {

    scope = scope || {};
    scope.componentContext = "=?";

    let def = defineDirective(controllerType, templateUrl, scope);

    def.link = (scope, element, attrs, ctrl: { _rootElement: any }) => {
        ctrl._rootElement = element[0]
    }

    return def

}
